import { resolveActionStepDescription } from '../ActionStepContent/ActionStepContent.utils';

export const mapActionStepPropsToGroupStep = (id, stepContentProps) => {
  const {
    label,
    status,
    summary = null,
    errorMessage = null,
    subStepType = null,
    toolName = null,
  } = stepContentProps ?? {};

  return {
    id,
    title: label,
    status,
    actionStepType: subStepType,
    toolName,
    description: resolveActionStepDescription(status, summary, errorMessage),
    content: [],
  };
};
